import { Component, PropsWithChildren, ReactNode } from "react"

import Button from '../buttons/Button'

export interface ModalProps {
    title: string
    buttonText?: string
    isOpen?: boolean
    isSigIn?: boolean
    callBackGoToSigIn?: Function
    isLogIn?: boolean
    callBackGoToLogIn?: Function
    callBackSendData?: Function
    callBackToggle: Function
    error?: string | undefined
    id?: string
}

export interface ModalState {}

class Modal extends Component<PropsWithChildren<ModalProps>, ModalState> {

    constructor (props: any) {
        super(props)

        this.sendAndClose = this.sendAndClose.bind(this)
        this.exit = this.exit.bind(this)
    }

    componentDidUpdate(prevProps: Readonly<PropsWithChildren<ModalProps>>, prevState: Readonly<ModalState>, snapshot?: any): void {
        let targetElement = document.querySelector(".generic-modal")

        if (this.props.isOpen) {    
            document.querySelector("body")?.classList.add("no-vertical-scrool")
            targetElement?.scrollIntoView( { behavior: 'smooth', block: 'start' } )
        }
        else {
            document.querySelector("body")?.classList.remove("no-vertical-scrool")
        }
    }    

    render(): ReactNode {
        const id = (this.props.id !== undefined) ? this.props.id : 'modal_' + Math.floor(Math.random() * 1000)
        return (
            (this.props.isOpen) &&
            <div className="modal-container">
                <div id={id} className="modal-fade-show generic-modal" tabIndex={-1}>
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <span className="modal-title titleLev4 colorPrimaryBlue mb-2">
                                    {this.props.title}
                                </span>
                                <button 
                                    type='button' 
                                    className='btn-close' 
                                    data-bs-dismiss='modal' 
                                    onClick={this.exit}
                                ></button>
                            </div>
                            <div className="modal-body">
                                {this.props.children}
                            </div>
                            <div className="modal-footer flex-column">
                                {this.props.error &&
                                    <>
                                        <p className='alert alert-danger'>
                                            <svg className="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Info:">
                                                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                                            </svg>
                                            <span>{this.props.error}</span>
                                        </p>
                                    </>
                                }

                                <Button 
                                    id='send-data'
                                    type="button" 
                                    className="btn btn-medium btn-secondary btn-full" 
                                    data-bs-dismiss="modal"
                                    onClick={this.sendAndClose}
                                >
                                    {this.props.buttonText}
                                </Button>
                                <br/>
                                { (this.props.isLogIn) &&
                                    <p className='text-center mt-4'>
                                        <a 
                                            href='https://www.6sicuro.it/nostri-contatti/' 
                                            target='_blank'  rel='noopener noreferrer'
                                            className='colorSecondaryGreen'
                                        >
                                            Hai bisogno di aiuto? Contattaci
                                        </a>
                                        <br/>
                                        Non hai ancora un account?
                                        <br/>
                                        <span id='registrati'
                                            className="colorPrimaryGreen cursor-pointer" 
                                            onClick={ () => this.props?.callBackGoToSigIn?.() }
                                        >
                                            Registrati
                                        </span>
                                    </p>
                                }

                                { (this.props.isSigIn) &&
                                    <p className='text-center mt-4'>
                                        Hai già un account?
                                        <br/>
                                        <span id='loggati'
                                            className="colorSecondaryGreen cursor-pointer" 
                                            onClick={ () => this.props.callBackGoToLogIn?.() }
                                        >
                                            Accedi
                                        </span>
                                    </p>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-fade-backdrop"></div>
            </div>
        )
    }

    private exit (e: React.MouseEvent<HTMLButtonElement>) {
        if (e?.stopPropagation && e.preventDefault) {
            e.stopPropagation()
            e.preventDefault()
        }
        this.props.callBackToggle ( false )
    }

    private sendAndClose (e: React.MouseEvent<HTMLButtonElement>) {
        if (e?.stopPropagation && e.preventDefault) {
            e.stopPropagation()
            e.preventDefault()
        }

        if (this.props.callBackSendData) {
            this.props.callBackSendData ()
        }
    }
}

export default Modal;